import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/lrg.styles.css";

export const LRG = () => {
	return <SubserviceWrapper config={services.lrg} />;
};
